import React, { useState, useEffect } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import { FaBell } from 'react-icons/fa';

function Navbar() {
    const { user, logout, token } = useAuth();
    const navigate = useNavigate();
    const [notificaciones, setNotificaciones] = useState([]);

    useEffect(() => {
        const fetchNotificaciones = async () => {
            if (!token) return;
            try {
                const response = await fetch('/api/notificaciones', {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (response.ok) {
                    const data = await response.json();
                    // --- CORRECCIÓN AÑADIDA ---
                    // Nos aseguramos de que 'data' sea un array antes de actualizar el estado.
                    if (Array.isArray(data)) {
                        setNotificaciones(data);
                    }
                }
            } catch (error) {
                console.error("Error al buscar notificaciones:", error);
            }
        };

        fetchNotificaciones();
        const intervalId = setInterval(fetchNotificaciones, 30000);

        return () => clearInterval(intervalId);
    }, [token]);

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    const handleNotificacionClick = async (notificacion) => {
        try {
            await fetch(`/api/notificaciones/${notificacion.id}/leida`, {
                method: 'PUT',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            setNotificaciones(prev => prev.filter(n => n.id !== notificacion.id));
            navigate(notificacion.enlace);
        } catch (error) {
            console.error("Error al marcar notificación:", error);
        }
    };
    
    const handleMarcarTodasLeidas = async () => {
        try {
            const response = await fetch(`/api/notificaciones/marcar-todas-leidas`, {
                method: 'PUT',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (response.ok) {
                setNotificaciones([]);
            }
        } catch (error) {
            console.error("Error al marcar todas las notificaciones como leídas:", error);
        }
    };

    return (
        <nav className="navbar navbar-expand-lg navbar-dark" style={{ backgroundColor: '#800020' }}>
            <div className="container-fluid">
                <Link className="navbar-brand" to="/dashboard">Plataforma GP</Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
                    <div className="navbar-nav me-auto">
                        {user && (
                            <>
                                <NavLink className="nav-link" to="/dashboard">Dashboard</NavLink>
                                {user.rol === 'admin' && (
                                     <li className="nav-item dropdown">
                                        <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownAdmin" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            Administración
                                        </a>
                                        <ul className="dropdown-menu" aria-labelledby="navbarDropdownAdmin">
                                            <li><Link className="dropdown-item" to="/admin/usuarios">Usuarios</Link></li>
                                            <li><Link className="dropdown-item" to="/admin/sistemas">Sistemas</Link></li>
                                            <li><Link className="dropdown-item" to="/admin/agencias">Agencias</Link></li>
                                            <li><Link className="dropdown-item" to="/admin/trabajos">Trabajos</Link></li>
                                        </ul>
                                    </li>
                                )}
                            </>
                        )}
                    </div>
                    <div className="d-flex align-items-center">
                        {user ? (
                            <>
                                <div className="dropdown">
                                    <button className="btn btn-link text-white position-relative" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                        <FaBell size="1.2em" />
                                        {notificaciones.length > 0 && (
                                            <span className="position-absolute top-0 start-85 translate-middle badge rounded-pill bg-danger">
                                                {notificaciones.length}
                                                <span className="visually-hidden">notificaciones no leídas</span>
                                            </span>
                                        )}
                                    </button>
                                    <ul 
                                        className="dropdown-menu dropdown-menu-end" 
                                        aria-labelledby="dropdownMenuButton1" 
                                        style={{ 
                                            maxHeight: '200px',   // <-- Alto
                                            overflowY: 'auto', 
                                            width: '600px',       // <-- Ancho 
                                            fontSize: '0.7rem'    // <-- Letra más pequeña
                                        }}
                                    >
                                        {notificaciones.length > 0 ? (
                                            notificaciones.map(notificacion => (
                                                <li key={notificacion.id}>
                                                    <a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); handleNotificacionClick(notificacion); }}>
                                                        {notificacion.mensaje}
                                                    </a>
                                                </li>
                                            ))
                                        ) : (
                                            <li><span className="dropdown-item-text">No hay notificaciones nuevas.</span></li>
                                        )}
                                        {notificaciones.length > 0 && (
                                            <>
                                                <li><hr className="dropdown-divider" /></li>
                                                <li>
                                                    <a className="dropdown-item text-center" href="#" onClick={(e) => { e.preventDefault(); handleMarcarTodasLeidas(); }}>
                                                        Marcar todas como leídas
                                                    </a>
                                                </li>
                                            </>
                                        )}
                                    </ul>
                                </div>

                                <span className="navbar-text ms-3 me-3">
                                    Hola, {user.nombre}
                                </span>
                                <button onClick={handleLogout} className="btn btn-outline-light btn-sm">Cerrar Sesión</button>
                            </>
                        ) : (
                            <Link to="/login" className="btn btn-outline-light">Iniciar Sesión</Link>
                        )}
                    </div>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;